import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";

const RadioIsActivate = ({
                           propTitle = '발송 활성 여부',
                           propDefaultValue,
                           propOnChange = null
                         }) => {

  return (
      <Form.Group as={Row} controlId='radioIsActivate'>
        <Form.Label column md={3} className={'label text-end fw-bold'}>
          <span className={"text-danger"}>* </span>{propTitle}
        </Form.Label>
        <Col md={9} className={''}>
          <Row>
            <Col md={3} className={'checkbox'}>
              <input type={"radio"} name={"active"} id={"active"} className={""} value={'1'}
                     onChange={propOnChange}
                     checked={propDefaultValue === 1}
              />
              <label htmlFor={"active"} className={'label text-end ps-1'}>
                활성
              </label>
            </Col>
            <Col md={3} className={'checkbox'}>
              <input type={"radio"} name={"active"} id={"inactive"} className={""} value={'0'}
                     onChange={propOnChange}
                     checked={propDefaultValue === 0}
              />
              <label htmlFor={"inactive"} className={'label text-end ps-1'}>
                비활성
              </label>
            </Col>
          </Row>
        </Col>
      </Form.Group>
  );
};

export default RadioIsActivate;